export default {
    java: 'java',
    xml: 'xml',
    yml: 'yml',
    '.gitignore': 'ignore',
    'Dockerfile': 'dockerfile',
    'sql': 'sql',
}
